// Styling für die aus .docx gerenderten Rechtstexte (AGB / Datenschutz).
//
// Word exportiert i.d.R. JEDE Überschrift (Dokumenttitel UND jeder §-Abschnitt)
// als "Heading 1" -> mammoth macht daraus lauter <h1>-Tags. Ohne Sonderbehandlung
// wären damit ALLE Paragraphen-Überschriften riesig (42px) — und lange deutsche
// Wörter ("Zahlungsbedingungen") sprengen dann auf dem Handy die Spaltenbreite,
// wodurch der ganze Bildschirm rauszoomt. Fix: nur der ERSTE h1 (Dokumenttitel)
// bekommt die große Schrift, alle weiteren h1 (= §-Abschnitte) werden wie normale
// Zwischenüberschriften behandelt. Zusätzlich erzwingt overflow-wrap, dass lange
// Wörter umbrechen statt die Seite zu verbreitern.
export const legalCSS = `
  .legal-content { overflow-wrap: break-word; word-break: break-word; hyphens: auto; }
  .legal-content h1 { font-size: clamp(18px, 4.5vw, 22px); font-weight: 700; margin: 32px 0 12px; line-height: 1.35; }
  .legal-content h1:first-of-type { font-size: clamp(28px, 8vw, 42px); font-weight: 800; margin: 0 0 28px; line-height: 1.15; }
  .legal-content h2 { font-size: clamp(17px, 4vw, 24px); font-weight: 700; margin: 28px 0 12px; line-height: 1.35; }
  .legal-content h3 { font-size: clamp(15px, 3.5vw, 18px); font-weight: 600; margin: 20px 0 10px; line-height: 1.4; }
  .legal-content p  { color: var(--text-secondary); line-height: 1.8; margin: 0 0 16px; font-size: 15px; }
  .legal-content ul, .legal-content ol { color: var(--text-secondary); line-height: 1.8; margin: 0 0 16px; padding-left: 22px; }
  .legal-content li { margin-bottom: 8px; }
  .legal-content a  { color: var(--accent); text-decoration: underline; overflow-wrap: anywhere; }
  .legal-content strong { color: var(--text-primary); font-weight: 700; }
  .legal-content img { max-width: 100%; height: auto; border-radius: 8px; }
  .legal-content table { border-collapse: collapse; width: 100%; margin: 0 0 16px; display: block; overflow-x: auto; }
  .legal-content th, .legal-content td { border: 1px solid var(--border); padding: 8px 12px; text-align: left; color: var(--text-secondary); }
  .legal-content th { color: var(--text-primary); font-weight: 700; }

  @media (max-width: 480px) {
    .legal-content p, .legal-content li { font-size: 14px; }
  }
`;
